<template>
  <div id="app">
    <MenuBar ref="MenuBar"/>
    <router-view style="margin-top:-7px;"/>
    
    <vue-progress-bar></vue-progress-bar>
    <div class="popupmessage-container">
      <popupmessage v-for="(popupmessage, imessage) in popupmessages" :message="popupmessage" :key="imessage"/>
    </div>
    <popupalert v-for="(popupalert, ialert) in popupalerts" :message="popupalert" :key="ialert"/>
    <rosterresult v-if="loggedIn"></rosterresult>
  </div>
</template>
<script>
  import MenuBar from './components/MenuBar.vue'
  import popupmessage from './components/uicomponents/popupmessage.vue'
  import popupalert from './components/uicomponents/popupalert.vue'
  import dropdown from './components/uicomponents/dropdown.vue'
  import rosterresult from './components/rostercontext/RosterResult.vue'

  export default{
    name: 'app',
    components: {
      MenuBar,
      dropdown,
      popupmessage,
      popupalert,
      rosterresult
    },
    data() {
        return {
            popupmessages: [],
            popupalerts: [],
        }
    },
    created(){
      document.body.addEventListener('mousemove', this.WatchMouse);
      document.body.addEventListener('mousedown', this.WatchMouse);
      document.body.addEventListener('mouseup', this.WatchMouse);
        document.addEventListener("touchstart", this.TouchEventToMouseEvent, {passive: false});
        document.addEventListener("touchmove", this.TouchEventToMouseEvent,  {passive: false});
        document.addEventListener("touchend", this.TouchEventToMouseEvent,  {passive: false});
        document.addEventListener("touchcancel", this.TouchEventToMouseEvent,  {passive: false});
      window.mouse = {x: 0, y: 0, click: false, element: {}};
      window.app = this;


    },
    computed: {
        loggedIn() {
            return this.$store.state.loggedIn;
        }
    },
    methods: {
      TouchEventToMouseEvent($event)
      {
          var touches = $event.changedTouches,
              first = touches[0],
              type = "";
          switch($event.type)
          {
              case "touchstart": type = "mousedown"; break;
              case "touchmove":
              {
                if(window.roster && window.roster.dayMode) $event.preventDefault();
                type = "mousemove";
                break;
              }
              case "touchend":   type = "mouseup";   break;
              default:           return;
          }

          var simulatedEvent = document.createEvent("MouseEvent");
          simulatedEvent.initMouseEvent(type, true, true, window, 1,
                                        first.screenX, first.screenY,
                                        first.clientX, first.clientY, false,
                                        false, false, false, 0/*left*/, null);

          first.target.dispatchEvent(simulatedEvent);
          //$event.preventDefault();
      },
      WatchMouse($event) {
        if($event.type === 'mousedown' && $event.which === 1) window.mouse.click = true;
        if($event.type === 'mouseup' && $event.which === 1) window.mouse.click = false;
        if($event.type === 'mousemove') {
          window.mouse.x = $event.clientX;
          window.mouse.y = $event.clientY;
          window.mouse.element = document.elementFromPoint($event.clientX, $event.clientY);
        }
      },
    }
  }
</script>

<style>
  @import './assets/styles/colors_dark.css';
  @import './assets/styles/colors_light.css';
  @import './assets/styles/md.css';
  @import './assets/styles/md_750px.css';
  @import './assets/styles/md_1380px.css';
  @import './assets/styles/dropdown.css';
</style>